import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "SelectedFiltersHeader"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tracking = _resolveComponent("Tracking")!
  const _component_SelectedFiltersSkeletonLoader = _resolveComponent("SelectedFiltersSkeletonLoader")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["SelectedFiltersContainer", { Visible: _ctx.filtersApplied || _ctx.isBusy }])
  }, [
    (_ctx.displayHeader && (_ctx.filtersApplied || _ctx.isBusy))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (_ctx.displayTitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Selected filters"))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.displayClearAll && _ctx.removableFiltersCount > 0 && !_ctx.isBusy)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ClearButton",
                ref: "clearAllButtonRef",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.removableFiltersCount === 1 ? 'Clear filter' : `Clear ${_ctx.removableFiltersCount} filters`) + " ", 1 /* TEXT */),
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "lnr-redo2 ButtonIcon" }, null, -1 /* CACHED */))
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true),
          (_ctx.clearAllButtonTrackingData)
            ? (_openBlock(), _createBlock(_component_Tracking, {
                key: 1,
                data: _ctx.clearAllButtonTrackingData
              }, null, 8 /* PROPS */, ["data"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isBusy)
      ? (_openBlock(), _createBlock(_component_SelectedFiltersSkeletonLoader, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([[_ctx.collapseToDefaultNumberOfRows ? 'Collapsed' : ''], "FilterTagContainer"]),
          ref: "filterTagContainerRef"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.id
            }, [
              _createVNode(_component_Tag, {
                tag: tag,
                icon: 'lnr-cross',
                trackClick: true,
                trackingPayload: _ctx.tagTrackingPayload[index]
              }, null, 8 /* PROPS */, ["tag", "trackingPayload"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */)),
    _createElementVNode("div", null, [
      (_ctx.collapseToDefaultNumberOfRows && _ctx.shouldDisplayShowMore)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ShowMoreButton",
            ref: "showMoreButtonRef",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Show more ", -1 /* CACHED */),
            _createElementVNode("i", { class: "lnr-plus ButtonIcon" }, null, -1 /* CACHED */)
          ]))], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (_ctx.collapseToDefaultNumberOfRows && _ctx.shouldDisplayShowLess)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "ShowLessButton",
            ref: "showLessButtonRef",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showLess && _ctx.showLess(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Show less ", -1 /* CACHED */),
            _createElementVNode("i", { class: "lnr-minus ButtonIcon" }, null, -1 /* CACHED */)
          ]))], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}